<template lang="pug">
.row.bg-white.product-type-list.mb-4
  .col-md-3.photo(
    v-if="product.photo",
    :style="{ backgroundImage: 'url(' + product.photo.image + ')' }"
  )
    h5.text-center.py-3 {{ product.name }}
  .col-md-9
    .py-4
      .py-3.px-4
        p(v-if="tab == 0")
          | {{ product.ic_desc }}
        p(v-else)
          | {{ product.module_desc }}
      .row.align-items-start
        .col-sm-9
          .px-4
            a.badge.badge-warning.badge-pill(
              v-for="(tag, index) in product.applications",
              :key="index",
              style="cursor: pointer",
              @click="tagClick(tag)"
            ) {{ tag.title }}

        .col-sm-3.text-right
          a.btn.btn-primary.px-4(v-if="tab == 0", @click="onBtnClick(1)") Module
          a.btn.btn-primary.px-4(v-else, @click="onBtnClick(0)") IC
</template>

<script>
export default {
  name: "ProductType",
  props: {
    product: Object,
    tab: Number,
  },
  methods: {
    tagClick(tag) {
      this.$router.push({
        name: "Application",
        params: {
          tab_id: tag.id,
        },
      });
    },
    onBtnClick(item) {
      this.$emit("descriptionTabClick", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-type-list .photo {
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 220px;
}

.product-type-list .col-md-3,
.product-type-list .col-md-9 {
  padding-right: 0px;
  padding-left: 0px;
}

.product-type-list .photo h5 {
  position: absolute;
  left: 5%;
  bottom: 10px;
  color: white;
  position: absolute;
  background-color: rgba(253, 177, 3, 0.9);
  width: 90%;
}

.product-type-list .badge {
  color: #faad00;
  border: #faad00 1px solid;
  background-color: transparent;
  font-weight: 300;
  padding: 0.5em 0.7em;
  margin-bottom: 0.5rem;
  margin-right: 3px;

  &:hover {
    color: white;
    background-color: #faad00;
  }
}

.product-type-list .btn {
  border-radius: 0.25rem 0 0 0.25rem;
}

.product-type-list {
  margin-left: 0;
  margin-right: 0;
}
</style>
